import React from 'react';
import { QuestRoute } from '../../api/QuestRoutes';
import Preput from '../../forms/Preput';
import FormSetting from '../../layout/FormSetting';
import PageBreak from '../../layout/PageBreak';
import HamQuest from '../../api/HamQuestGiver';
import { userRoles } from '../../RoleProtected';
import UpgradeAndAutoSelect from '../../forms/formComponents/UpgradeAndAutoSelect';

const WashBundleSettings = ({ ...props }) => {

    return (
        <PageBreak>
            <FormSetting
                label='Wash Bundle Settings'
                getInputs={QuestRoute.codes.washBundleSettings}
                onSubmit={e => HamQuest.put(QuestRoute.codes.washBundleSettings, e)}
                editable
                roles={userRoles.accountConfiguration}
            >
                {(values) => <>
                    <PageBreak>
                        <UpgradeAndAutoSelect
                            autoSelectFieldName='autoSelect'
                        />
                        <Preput
                            label='Issue Receipt'
                            name='issueMsg'
                            tags={['UseCount', 'UsesRemaining', 'ExpirationDate', 'MaxUses', 'KioskItemName']}
                            required
                        />
                        <Preput
                            label='Receipt'
                            name='receiptMsg'
                            tags={['UseCount', 'UsesRemaining', 'ExpirationDate', 'MaxUses', 'KioskItemName']}
                            required
                        />
                    </PageBreak>
                </>}
            </FormSetting>
        </PageBreak>
    );
}

export default WashBundleSettings;
